import { css } from '@emotion/react'
import { DigitalLegacyReviewItem } from 'components/digitalLegacy/digitalLegacyReview/digitalLegacyReviewItem/DigitalLegacyReviewItem'
import { Stack } from 'components/Stack'
import { Title, Title_h3_default } from 'components/Typography'
import AmazonReview from 'images/extra-svg/AmazonReview.svg'
import { forwardRef } from 'react'
import { pxToRem } from 'utils/styled'

export const DigitalLegacyReview = forwardRef<
  HTMLDivElement,
  {
    viewReviewUrl?: string | null
    className?: string
    title?: string | null
    items?:
      | {
          name?: string | null
          description?: string | null
          jobTitle?: string | null
          photo?: string | null
        }[]
      | null
  }
>((props, ref) => {
  return (
    <Stack
      className={props.className}
      ref={ref}
      space={`${pxToRem(77)}rem`}
      css={css`
        align-items: center;
        padding-top: ${pxToRem(70)}rem;
        padding-bottom: ${pxToRem(160)}rem;
      `}
    >
      <Title variant={Title_h3_default} as="h3" css={{ textAlign: 'center' }}>
        {props.title}
      </Title>

      <div
        css={css`
          display: grid;
          grid-gap: ${pxToRem(60)}rem;
          grid-template-columns: repeat(auto-fill, minmax(${pxToRem(280)}rem, 1fr));
        `}
      >
        {props.items?.map((item, index) => (
          <DigitalLegacyReviewItem
            key={item.name ?? index}
            src={item.photo ?? undefined}
            name={item.name}
            description={item.description ?? undefined}
            jobTitle={item.jobTitle ?? undefined}
          />
        ))}
      </div>
      <a href={props.viewReviewUrl ?? undefined} target="_blank" rel="noreferrer">
        <AmazonReview css={{ cursor: 'pointer' }} />
      </a>
    </Stack>
  )
})

DigitalLegacyReview.displayName = 'DigitalLegacyReview'
